// extracted by mini-css-extract-plugin
export default {"overlay":"FocusOverlay_overlay__eYJdA","hint":"FocusOverlay_hint__kqUzO","stretch":"FocusOverlay_stretch__rQHsy"};